import React, { useState } from 'react';
import './MockDataDemo.css';

const MockDataDemo = () => {
  const [activeTab, setActiveTab] = useState('menuItems');
  
  // Gift Card Demo State
  const [giftCardSetupStep, setGiftCardSetupStep] = useState(1);
  const [giftCardAmount, setGiftCardAmount] = useState('');
  const [giftCardNumber, setGiftCardNumber] = useState('');
  const [giftCardBalance, setGiftCardBalance] = useState(0);
  const [giftCardActivated, setGiftCardActivated] = useState(false);
  const [transactionHistory, setTransactionHistory] = useState([]);

  // Mock Menu Items matching Toast API MenuItem schema
  const mockMenuItems = [
    {
      guid: '95c5d500-8d92-46f2-bec4-fb2a42a46621',
      name: 'Classic Taco',
      kitchenName: 'TACO-CLS',
      description: 'Traditional taco with seasoned beef',
      price: 3.99,
      pricingStrategy: 'BASE_PRICE',
      calories: 210,
      sku: 'TAC-001',
      plu: '1001',
      salesCategory: { name: 'Food', guid: 'sc-001' },
      taxInclusion: 'TAX_NOT_INCLUDED',
      isDiscountable: true
    },
    {
      guid: '85c6d600-9e93-57g3-cfd5-gc3a53a57732',
      name: 'Burrito Bowl',
      kitchenName: 'BOWL-BUR',
      description: 'Rice bowl with choice of protein and toppings',
      price: 12.99,
      pricingStrategy: 'MENU_SPECIFIC_PRICE',
      calories: 650,
      sku: 'BWL-002',
      plu: '1002',
      salesCategory: { name: 'Food', guid: 'sc-001' },
      taxInclusion: 'TAX_NOT_INCLUDED',
      isDiscountable: true
    },
    {
      guid: '75c7d700-0fa4-68h4-dgf6-hd4b64b68843',
      name: 'Margarita',
      kitchenName: 'MGR-CLS',
      description: 'Classic lime margarita on the rocks',
      price: 8.99,
      pricingStrategy: 'TIME_SPECIFIC_PRICE',
      calories: 220,
      sku: 'DRK-001',
      plu: '2001',
      salesCategory: { name: 'Alcohol', guid: 'sc-002' },
      taxInclusion: 'TAX_NOT_INCLUDED',
      isDiscountable: false,
      contentAdvisories: { alcohol: { containsAlcohol: 'YES' } }
    },
    {
      guid: '65c8d800-1gb5-79i5-ehg7-ie5c75c79954',
      name: 'Guacamole & Chips',
      kitchenName: 'GUAC-APP',
      description: 'Fresh made guacamole with tortilla chips',
      price: 7.99,
      pricingStrategy: 'BASE_PRICE',
      calories: 380,
      sku: 'APP-001',
      plu: '3001',
      salesCategory: { name: 'Food', guid: 'sc-001' },
      taxInclusion: 'TAX_NOT_INCLUDED',
      isDiscountable: true
    }
  ];

  // Mock Orders matching Toast API Order schema
  const mockOrders = [
    {
      guid: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
      entityType: 'Order',
      openedDate: '2026-01-15T18:30:00.000Z',
      promisedDate: '2026-01-15T19:00:00.000Z',
      diningOption: { behavior: 'DINE_IN' },
      checks: [
        {
          guid: 'c1d2e3f4-a5b6-c7d8-e9f0-123456789abc',
          entityType: 'Check',
          displayNumber: '101',
          totalAmount: 28.47,
          taxAmount: 2.28,
          selections: [
            {
              guid: 's1a2b3c4-d5e6-f7g8-h9i0-jklmnopqrstu',
              itemId: '95c5d500-8d92-46f2-bec4-fb2a42a46621',
              itemName: 'Classic Taco',
              quantity: 2,
              preDiscountPrice: 7.98
            },
            {
              guid: 's2b3c4d5-e6f7-g8h9-i0j1-klmnopqrstuvw',
              itemId: '65c8d800-1gb5-79i5-ehg7-ie5c75c79954',
              itemName: 'Guacamole & Chips',
              quantity: 1,
              preDiscountPrice: 7.99
            },
            {
              guid: 's3c4d5e6-f7g8-h9i0-j1k2-lmnopqrstuvwx',
              itemId: '75c7d700-0fa4-68h4-dgf6-hd4b64b68843',
              itemName: 'Margarita',
              quantity: 1,
              preDiscountPrice: 8.99
            }
          ],
          payments: []
        }
      ],
      voided: false,
      voidDate: null
    },
    {
      guid: 'b2c3d4e5-f6g7-8901-bcde-f12345678901',
      entityType: 'Order',
      openedDate: '2026-01-15T17:45:00.000Z',
      promisedDate: '2026-01-15T18:15:00.000Z',
      diningOption: { behavior: 'TAKEOUT' },
      checks: [
        {
          guid: 'd2e3f4g5-b6c7-d8e9-f0g1-234567890bcd',
          entityType: 'Check',
          displayNumber: '102',
          totalAmount: 42.76,
          taxAmount: 3.42,
          selections: [
            {
              guid: 's4d5e6f7-g8h9-i0j1-k2l3-mnopqrstuvwxy',
              itemId: '85c6d600-9e93-57g3-cfd5-gc3a53a57732',
              itemName: 'Burrito Bowl',
              quantity: 3,
              preDiscountPrice: 38.97
            }
          ],
          payments: [
            {
              guid: 'p1a2b3c4-d5e6-f7g8-h9i0-payment123456',
              entityType: 'Payment',
              paidDate: '2026-01-15T17:50:00.000Z',
              amount: 42.76,
              tipAmount: 8.00,
              paymentStatus: 'CAPTURED',
              type: 'CREDIT'
            }
          ]
        }
      ],
      voided: false,
      voidDate: null
    }
  ];

  // Mock Modifier Groups matching Toast API ModifierGroup schema
  const mockModifierGroups = [
    {
      guid: '23c02762-9d6a-4d3f-a298-71c989bf31b0',
      referenceId: 2,
      name: 'Size',
      pricingStrategy: 'NONE',
      minSelections: 1,
      maxSelections: 1,
      requiredMode: 'REQUIRED',
      isMultiSelect: false,
      modifierOptions: [
        { guid: '352244f2-a952-4a3a-a3ae-7775fa221ce7', referenceId: 12, name: 'Small', price: 0.00 },
        { guid: '4ff89bca-b448-4892-bc4c-62c37a28ac44', referenceId: 13, name: 'Large', price: 2.00 }
      ]
    },
    {
      guid: '58b79986-f88f-411d-ba18-14b1e2441e9d',
      referenceId: 3,
      name: 'Toppings',
      pricingStrategy: 'SEQUENCE_PRICE',
      minSelections: 0,
      maxSelections: null,
      requiredMode: 'OPTIONAL',
      isMultiSelect: true,
      modifierOptions: [
        { guid: 'fa24fee9-76c4-40ba-ae3c-7dfccafdd8d3', referenceId: 10, name: 'Mushrooms', price: 1.50 },
        { guid: 'afee6be7-8280-4c69-a170-9fdf4c76bf7b', referenceId: 11, name: 'Onions', price: 1.50 },
        { guid: 'bfee7cf8-9391-5d7a-b281-0gfe5d87cg8c', referenceId: 14, name: 'Jalapeños', price: 1.50 },
        { guid: 'cfee8dg9-0402-6e8b-c392-1hgf6e98dh9d', referenceId: 15, name: 'Extra Cheese', price: 2.00 }
      ]
    }
  ];

  // Mock Restaurant Configuration matching Toast API Restaurant schema
  const mockRestaurantConfig = {
    guid: '2071fb81-988b-4d75-b8dc-c5c17cff9706',
    restaurantGuid: '2071fb81-988b-4d75-b8dc-c5c17cff9706',
    name: "Chula's Cantina",
    restaurantTimeZone: 'America/Chicago',
    lastUpdated: '2026-01-15T23:30:00.000Z',
    description: 'Authentic Mexican cuisine and cocktails',
    closeoutHour: 4,
    prepStations: [
      { guid: 'ps-001', name: 'Grill Station' },
      { guid: 'ps-002', name: 'Cold Prep' },
      { guid: 'ps-003', name: 'Bar' }
    ],
    taxRates: [
      { guid: 'tr-001', name: 'State Tax', rate: 0.0625, type: 'PERCENT' },
      { guid: 'tr-002', name: 'City Tax', rate: 0.02, type: 'PERCENT' }
    ]
  };

  // Mock Payments matching Toast API Payment schema
  const mockPayments = [
    {
      guid: 'p1a2b3c4-d5e6-f7g8-h9i0-payment123456',
      entityType: 'Payment',
      paidDate: '2026-01-15T17:50:00.000Z',
      paidBusinessDate: '2026-01-15',
      type: 'CREDIT',
      cardType: 'VISA',
      amount: 42.76,
      tipAmount: 8.00,
      amountTendered: 50.76,
      paymentStatus: 'CAPTURED',
      lastModified: '2026-01-15T17:50:15.000Z',
      refund: { refundStatus: 'NONE', refundAmount: 0.00 }
    },
    {
      guid: 'p2b3c4d5-e6f7-g8h9-i0j1-payment234567',
      entityType: 'Payment',
      paidDate: '2026-01-15T18:15:00.000Z',
      paidBusinessDate: '2026-01-15',
      type: 'CASH',
      amount: 35.50,
      tipAmount: 5.00,
      amountTendered: 45.00,
      cashDrawer: { guid: 'cd-001', name: 'Register 1' },
      paymentStatus: 'CAPTURED',
      lastModified: '2026-01-15T18:15:20.000Z',
      refund: { refundStatus: 'NONE', refundAmount: 0.00 }
    },
    {
      guid: 'p3c4d5e6-f7g8-h9i0-j1k2-payment345678',
      entityType: 'Payment',
      paidDate: '2026-01-15T19:30:00.000Z',
      paidBusinessDate: '2026-01-15',
      type: 'GIFT_CARD',
      amount: 28.99,
      tipAmount: 0.00,
      amountTendered: 28.99,
      paymentStatus: 'CAPTURED',
      lastModified: '2026-01-15T19:30:10.000Z',
      refund: { refundStatus: 'NONE', refundAmount: 0.00 }
    }
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'menuItems':
        return (
          <div className="mock-table-container">
            <h3>Menu Items (Toast API Schema)</h3>
            <div className="api-info">
              <span className="api-badge">Toast Menus API v3</span>
              <span className="schema-info">Schema: MenuItem</span>
            </div>
            <table className="mock-table">
              <thead>
                <tr>
                  <th>GUID</th>
                  <th>Name</th>
                  <th>Kitchen Name</th>
                  <th>Price</th>
                  <th>Pricing Strategy</th>
                  <th>SKU/PLU</th>
                  <th>Calories</th>
                  <th>Sales Category</th>
                </tr>
              </thead>
              <tbody>
                {mockMenuItems.map(item => (
                  <tr key={item.guid}>
                    <td><code className="guid-code">{item.guid.slice(0, 8)}...</code></td>
                    <td><strong>{item.name}</strong></td>
                    <td><span className="kitchen-name">{item.kitchenName}</span></td>
                    <td className="price-cell">${item.price.toFixed(2)}</td>
                    <td><span className="strategy-badge">{item.pricingStrategy}</span></td>
                    <td>{item.sku} / {item.plu}</td>
                    <td>{item.calories} cal</td>
                    <td>{item.salesCategory.name}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        );

      case 'orders':
        return (
          <div className="mock-table-container">
            <h3>Orders (Toast API Schema)</h3>
            <div className="api-info">
              <span className="api-badge">Toast Orders API</span>
              <span className="schema-info">Schema: Order</span>
            </div>
            {mockOrders.map(order => (
              <div key={order.guid} className="order-card">
                <div className="order-header">
                  <div>
                    <strong>Order GUID:</strong> <code className="guid-code">{order.guid}</code>
                  </div>
                  <span className="dining-badge">{order.diningOption.behavior}</span>
                </div>
                <div className="order-details">
                  <div><strong>Opened:</strong> {new Date(order.openedDate).toLocaleString()}</div>
                  <div><strong>Promised:</strong> {new Date(order.promisedDate).toLocaleString()}</div>
                  <div><strong>Voided:</strong> {order.voided ? 'Yes' : 'No'}</div>
                </div>
                {order.checks.map(check => (
                  <div key={check.guid} className="check-section">
                    <h4>Check #{check.displayNumber}</h4>
                    <div className="check-totals">
                      <div><strong>Total:</strong> ${check.totalAmount.toFixed(2)}</div>
                      <div><strong>Tax:</strong> ${check.taxAmount.toFixed(2)}</div>
                    </div>
                    <table className="selections-table">
                      <thead>
                        <tr>
                          <th>Item</th>
                          <th>Qty</th>
                          <th>Price</th>
                        </tr>
                      </thead>
                      <tbody>
                        {check.selections.map(sel => (
                          <tr key={sel.guid}>
                            <td>{sel.itemName}</td>
                            <td>{sel.quantity}</td>
                            <td>${sel.preDiscountPrice.toFixed(2)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {check.payments.length > 0 && (
                      <div className="payments-section">
                        <strong>Payments:</strong>
                        {check.payments.map(payment => (
                          <div key={payment.guid} className="payment-item">
                            <span className="payment-type">{payment.type}</span>
                            <span>${payment.amount.toFixed(2)}</span>
                            <span className="payment-status">{payment.paymentStatus}</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            ))}
          </div>
        );

      case 'modifiers':
        return (
          <div className="mock-table-container">
            <h3>Modifier Groups (Toast API Schema)</h3>
            <div className="api-info">
              <span className="api-badge">Toast Menus API v3</span>
              <span className="schema-info">Schema: ModifierGroup</span>
            </div>
            {mockModifierGroups.map(group => (
              <div key={group.guid} className="modifier-card">
                <div className="modifier-header">
                  <h4>{group.name}</h4>
                  <code className="guid-code">{group.guid.slice(0, 13)}...</code>
                </div>
                <div className="modifier-details">
                  <div><strong>Ref ID:</strong> {group.referenceId}</div>
                  <div><strong>Pricing:</strong> <span className="strategy-badge">{group.pricingStrategy}</span></div>
                  <div><strong>Required:</strong> {group.requiredMode}</div>
                  <div><strong>Min/Max:</strong> {group.minSelections}/{group.maxSelections || '∞'}</div>
                  <div><strong>Multi-Select:</strong> {group.isMultiSelect ? 'Yes' : 'No'}</div>
                </div>
                <table className="modifier-options-table">
                  <thead>
                    <tr>
                      <th>Option Name</th>
                      <th>Ref ID</th>
                      <th>Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    {group.modifierOptions.map(option => (
                      <tr key={option.guid}>
                        <td>{option.name}</td>
                        <td>{option.referenceId}</td>
                        <td>${option.price.toFixed(2)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ))}
          </div>
        );

      case 'payments':
        return (
          <div className="mock-table-container">
            <h3>Payments (Toast API Schema)</h3>
            <div className="api-info">
              <span className="api-badge">Toast Orders API</span>
              <span className="schema-info">Schema: Payment</span>
            </div>
            <table className="mock-table">
              <thead>
                <tr>
                  <th>GUID</th>
                  <th>Type</th>
                  <th>Paid Date</th>
                  <th>Amount</th>
                  <th>Tip</th>
                  <th>Status</th>
                  <th>Refund Status</th>
                </tr>
              </thead>
              <tbody>
                {mockPayments.map(payment => (
                  <tr key={payment.guid}>
                    <td><code className="guid-code">{payment.guid.slice(0, 8)}...</code></td>
                    <td><span className="payment-type-badge">{payment.type}</span></td>
                    <td>{new Date(payment.paidDate).toLocaleString()}</td>
                    <td className="price-cell">${payment.amount.toFixed(2)}</td>
                    <td className="price-cell">${payment.tipAmount.toFixed(2)}</td>
                    <td><span className="status-badge status-active">{payment.paymentStatus}</span></td>
                    <td><span className="status-badge status-completed">{payment.refund.refundStatus}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        );

      case 'restaurant':
        return (
          <div className="mock-table-container">
            <h3>Restaurant Configuration (Toast API Schema)</h3>
            <div className="api-info">
              <span className="api-badge">Toast Restaurants API</span>
              <span className="schema-info">Schema: Restaurant</span>
            </div>
            <div className="restaurant-config">
              <div className="config-section">
                <h4>Basic Information</h4>
                <div className="config-grid">
                  <div className="config-item">
                    <strong>GUID:</strong>
                    <code className="guid-code">{mockRestaurantConfig.guid}</code>
                  </div>
                  <div className="config-item">
                    <strong>Name:</strong>
                    <span>{mockRestaurantConfig.name}</span>
                  </div>
                  <div className="config-item">
                    <strong>Timezone:</strong>
                    <span>{mockRestaurantConfig.restaurantTimeZone}</span>
                  </div>
                  <div className="config-item">
                    <strong>Closeout Hour:</strong>
                    <span>{mockRestaurantConfig.closeoutHour}:00 AM</span>
                  </div>
                  <div className="config-item">
                    <strong>Last Updated:</strong>
                    <span>{new Date(mockRestaurantConfig.lastUpdated).toLocaleString()}</span>
                  </div>
                </div>
              </div>

              <div className="config-section">
                <h4>Prep Stations</h4>
                <ul className="config-list">
                  {mockRestaurantConfig.prepStations.map(station => (
                    <li key={station.guid}>
                      <code>{station.guid}</code> - {station.name}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="config-section">
                <h4>Tax Rates</h4>
                <table className="mock-table">
                  <thead>
                    <tr>
                      <th>GUID</th>
                      <th>Name</th>
                      <th>Rate</th>
                      <th>Type</th>
                    </tr>
                  </thead>
                  <tbody>
                    {mockRestaurantConfig.taxRates.map(rate => (
                      <tr key={rate.guid}>
                        <td><code className="guid-code">{rate.guid}</code></td>
                        <td>{rate.name}</td>
                        <td>{(rate.rate * 100).toFixed(2)}%</td>
                        <td>{rate.type}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        );

      case 'giftcard':
        return renderGiftCardSetup();

      default:
        return null;
    }
  };

  // Gift Card Setup Process Functions
  const generateGiftCardNumber = () => {
    return 'GC-' + Math.random().toString(36).substring(2, 15).toUpperCase();
  };

  const handleActivateGiftCard = () => {
    if (!giftCardAmount || parseFloat(giftCardAmount) <= 0) {
      alert('Please enter a valid amount');
      return;
    }
    const cardNumber = generateGiftCardNumber();
    const amount = parseFloat(giftCardAmount);
    
    setGiftCardNumber(cardNumber);
    setGiftCardBalance(amount);
    setGiftCardActivated(true);
    
    addTransaction({
      type: 'GIFTCARD_ACTIVATE',
      amount: amount,
      cardNumber: cardNumber,
      timestamp: new Date().toISOString(),
      status: 'ACCEPT',
      transactionGuid: 'txn-' + Math.random().toString(36).substring(2, 10)
    });
    
    setGiftCardSetupStep(2);
  };

  const handleAddValue = () => {
    const additionalAmount = parseFloat(prompt('Enter amount to add:', '25.00'));
    if (!additionalAmount || additionalAmount <= 0) return;
    
    const newBalance = giftCardBalance + additionalAmount;
    setGiftCardBalance(newBalance);
    
    addTransaction({
      type: 'GIFTCARD_ADD_VALUE',
      amount: additionalAmount,
      cardNumber: giftCardNumber,
      timestamp: new Date().toISOString(),
      status: 'ACCEPT',
      transactionGuid: 'txn-' + Math.random().toString(36).substring(2, 10),
      newBalance: newBalance
    });
  };

  const handleCheckBalance = () => {
    addTransaction({
      type: 'GIFTCARD_GET_BALANCE',
      amount: 0,
      cardNumber: giftCardNumber,
      timestamp: new Date().toISOString(),
      status: 'ACCEPT',
      transactionGuid: 'txn-' + Math.random().toString(36).substring(2, 10),
      currentBalance: giftCardBalance
    });
  };

  const handleRedeem = () => {
    const redeemAmount = parseFloat(prompt('Enter amount to redeem:', '10.00'));
    if (!redeemAmount || redeemAmount <= 0) return;
    
    if (redeemAmount > giftCardBalance) {
      alert('Insufficient balance!');
      return;
    }
    
    const newBalance = giftCardBalance - redeemAmount;
    setGiftCardBalance(newBalance);
    
    addTransaction({
      type: 'GIFTCARD_REDEEM',
      amount: -redeemAmount,
      cardNumber: giftCardNumber,
      timestamp: new Date().toISOString(),
      status: 'ACCEPT',
      transactionGuid: 'txn-' + Math.random().toString(36).substring(2, 10),
      newBalance: newBalance
    });
  };

  const addTransaction = (transaction) => {
    setTransactionHistory(prev => [transaction, ...prev]);
  };

  const resetGiftCardDemo = () => {
    setGiftCardSetupStep(1);
    setGiftCardAmount('');
    setGiftCardNumber('');
    setGiftCardBalance(0);
    setGiftCardActivated(false);
    setTransactionHistory([]);
  };

  const renderGiftCardSetup = () => {
    return (
      <div className="mock-table-container">
        <h3>Gift Card Setup Process Demo</h3>
        <div className="api-info">
          <span className="api-badge">Toast Gift Card Integration API</span>
          <span className="schema-info">Interactive Demo</span>
        </div>

        <div className="giftcard-demo-container">
          {/* Step Progress Indicator */}
          <div className="setup-steps">
            <div className={`setup-step ${giftCardSetupStep >= 1 ? 'active' : ''} ${giftCardSetupStep > 1 ? 'completed' : ''}`}>
              <div className="step-number">1</div>
              <div className="step-label">Activate Card</div>
            </div>
            <div className="step-connector"></div>
            <div className={`setup-step ${giftCardSetupStep >= 2 ? 'active' : ''} ${giftCardSetupStep > 2 ? 'completed' : ''}`}>
              <div className="step-number">2</div>
              <div className="step-label">Use Card</div>
            </div>
            <div className="step-connector"></div>
            <div className={`setup-step ${giftCardSetupStep >= 3 ? 'active' : ''}`}>
              <div className="step-number">3</div>
              <div className="step-label">View History</div>
            </div>
          </div>

          {/* Step 1: Activate Card */}
          {giftCardSetupStep === 1 && (
            <div className="giftcard-step-content">
              <h4>Step 1: Activate Gift Card</h4>
              <p>Enter the initial value for the gift card to activate it.</p>
              
              <div className="giftcard-form">
                <div className="form-group">
                  <label>Initial Amount ($):</label>
                  <input
                    type="number"
                    value={giftCardAmount}
                    onChange={(e) => setGiftCardAmount(e.target.value)}
                    placeholder="50.00"
                    min="0"
                    step="0.01"
                  />
                </div>
                <button className="primary-button" onClick={handleActivateGiftCard}>
                  Activate Gift Card
                </button>
              </div>

              <div className="api-example">
                <h5>Toast API Request (GIFTCARD_ACTIVATE):</h5>
                <pre>{JSON.stringify({
                  transactionType: 'GIFTCARD_ACTIVATE',
                  initialBalance: parseFloat(giftCardAmount) || 0,
                  restaurantGuid: '2071fb81-988b-4d75-b8dc-c5c17cff9706',
                  activatedDate: new Date().toISOString()
                }, null, 2)}</pre>
              </div>
            </div>
          )}

          {/* Step 2: Use Card */}
          {giftCardSetupStep === 2 && (
            <div className="giftcard-step-content">
              <h4>Step 2: Gift Card Operations</h4>
              
              <div className="giftcard-info-card">
                <div className="card-visual">
                  <div className="card-number">Card: {giftCardNumber}</div>
                  <div className="card-balance">${giftCardBalance.toFixed(2)}</div>
                  <div className="card-status">
                    <span className="status-badge status-active">ACTIVE</span>
                  </div>
                </div>
              </div>

              <div className="giftcard-actions">
                <button className="action-button add-value-btn" onClick={handleAddValue}>
                  💰 Add Value
                </button>
                <button className="action-button check-balance-btn" onClick={handleCheckBalance}>
                  💳 Check Balance
                </button>
                <button className="action-button redeem-btn" onClick={handleRedeem}>
                  🛒 Redeem
                </button>
                <button className="action-button history-btn" onClick={() => setGiftCardSetupStep(3)}>
                  📊 View History
                </button>
              </div>

              <div className="transaction-types-info">
                <h5>Available Transaction Types:</h5>
                <ul>
                  <li><strong>GIFTCARD_ADD_VALUE:</strong> Add funds to the card</li>
                  <li><strong>GIFTCARD_GET_BALANCE:</strong> Check current balance</li>
                  <li><strong>GIFTCARD_REDEEM:</strong> Use card for purchase</li>
                  <li><strong>GIFTCARD_REVERSE:</strong> Reverse a transaction</li>
                </ul>
              </div>
            </div>
          )}

          {/* Step 3: Transaction History */}
          {giftCardSetupStep === 3 && (
            <div className="giftcard-step-content">
              <h4>Step 3: Transaction History</h4>
              
              <div className="giftcard-summary">
                <div className="summary-item">
                  <strong>Card Number:</strong> {giftCardNumber}
                </div>
                <div className="summary-item">
                  <strong>Current Balance:</strong> ${giftCardBalance.toFixed(2)}
                </div>
                <div className="summary-item">
                  <strong>Total Transactions:</strong> {transactionHistory.length}
                </div>
              </div>

              <table className="mock-table">
                <thead>
                  <tr>
                    <th>Transaction Type</th>
                    <th>Amount</th>
                    <th>Timestamp</th>
                    <th>Transaction ID</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {transactionHistory.map((txn, index) => (
                    <tr key={index}>
                      <td>
                        <span className="transaction-type-badge">
                          {txn.type.replace('GIFTCARD_', '')}
                        </span>
                      </td>
                      <td className={txn.amount >= 0 ? 'positive-amount' : 'negative-amount'}>
                        {txn.amount >= 0 ? '+' : ''}{txn.amount !== 0 ? `$${txn.amount.toFixed(2)}` : '-'}
                      </td>
                      <td>{new Date(txn.timestamp).toLocaleString()}</td>
                      <td><code className="guid-code">{txn.transactionGuid}</code></td>
                      <td><span className="status-badge status-active">{txn.status}</span></td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="demo-actions">
                <button className="secondary-button" onClick={() => setGiftCardSetupStep(2)}>
                  ← Back to Operations
                </button>
                <button className="reset-button" onClick={resetGiftCardDemo}>
                  🔄 Reset Demo
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="mock-data-demo-container">
      <div className="page-header-section">
        <h2>🔧 Toast API Mock Data Demo</h2>
        <p>Sample data structures matching Toast POS API specifications</p>
      </div>

      <div className="demo-tabs">
        <button
          className={`demo-tab ${activeTab === 'menuItems' ? 'active' : ''}`}
          onClick={() => setActiveTab('menuItems')}
        >
          📋 Menu Items
        </button>
        <button
          className={`demo-tab ${activeTab === 'orders' ? 'active' : ''}`}
          onClick={() => setActiveTab('orders')}
        >
          🧾 Orders
        </button>
        <button
          className={`demo-tab ${activeTab === 'modifiers' ? 'active' : ''}`}
          onClick={() => setActiveTab('modifiers')}
        >
          🔧 Modifiers
        </button>
        <button
          className={`demo-tab ${activeTab === 'payments' ? 'active' : ''}`}
          onClick={() => setActiveTab('payments')}
        >
          💳 Payments
        </button>
        <button
          className={`demo-tab ${activeTab === 'restaurant' ? 'active' : ''}`}
          onClick={() => setActiveTab('restaurant')}
        >
          🏪 Restaurant Config
        </button>
        <button
          className={`demo-tab ${activeTab === 'giftcard' ? 'active' : ''}`}
          onClick={() => setActiveTab('giftcard')}
        >
          🎁 Gift Card Setup
        </button>
      </div>

      <div className="demo-content">
        {renderContent()}
      </div>

      <div className="demo-info">
        <div className="info-card">
          <h4>ℹ️ About This Demo</h4>
          <p>
            This page displays mock data structured according to the <strong>Toast POS API specifications</strong>.
            All data shown matches the official Toast API schemas including:
          </p>
          <ul>
            <li><strong>Menus API v3:</strong> MenuItem, ModifierGroup, ModifierOption schemas</li>
            <li><strong>Orders API:</strong> Order, Check, Selection, Payment schemas</li>
            <li><strong>Restaurants API:</strong> Restaurant configuration schema</li>
          </ul>
          <p className="note">
            <strong>Note:</strong> This is demonstration data only. GUIDs, prices, and other values are 
            fictional examples following Toast API data structure patterns.
          </p>
        </div>
      </div>
    </div>
  );
};

export default MockDataDemo;
